import content from "./site/content";
import { Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar2';
import Footer from './components/Footer';
import PageAccueil from './components/PageAccueil';
import PageNosGites from './components/PageNosGites';
import PageTarifs from './components/PageTarifs';
import PageNosVideos from './components/PageNosVideos';
import PageContact from './components/PageContact';
import DepthEffects from './components/DepthEffects';
import { gites, gitePath } from './site/data';
import './site/site.css';
export default function App() {
  return <>
    <DepthEffects />
    <a className="skip-link" href="#contenu">{content.navigation.skip}</a>
    <NavBar />
    <main id="contenu" tabIndex={-1}>
      <Routes>
        <Route path="/" element={<PageAccueil />} />
        {gites.map(gite => <Route key={gite.initial} path={gitePath(gite)} element={<PageNosGites key={gite.initial} initial={gite.initial} />} />)}
        <Route path="/hebergement-a-marie-galante/les-joyeux-saphir" element={<Navigate to="/hebergement-a-marie-galante/le-joyeux-saphir" replace />} />
        <Route path="/nos-tarifs" element={<PageTarifs />} />
        <Route path="/nos-videos" element={<PageNosVideos />} />
        <Route path="/contact" element={<PageContact />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
    <Footer />
  </>;
}
